import i18n from "@i18n/i18n";
import axios, { AxiosInstance } from "axios";

export { };
declare global {
  interface Window {
    axios: AxiosInstance;
  }
}

// TODO: rename this file to avoid name conflict and typing issues

axios.defaults.baseURL = window.location.origin;
axios.defaults.withCredentials = true;
axios.defaults.headers.post["Content-Type"] = "application/json";

const instance = axios.create({
  baseURL: window.location.origin,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});
window.axios = instance;

// Set the AUTH token for any request
instance.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem("accessToken");
    request.headers.Authorization = token ? `Bearer ${token}` : "";

    // NOTE: nswag isn't adding the correct Content-Type header for endpoints decorated with
    // [Consumes("multipart/form-data")]
    if (request.url?.includes("/image")) {
      request.headers.set("Content-Type", "multipart/form-data");
    }
    if (request.url?.includes("/api/templates?templateType") && request.method?.toUpperCase() == 'POST') {
      request.headers.set("Content-Type", "multipart/form-data");
    }
    if (request.url?.includes("/upload")) {
      request.headers.set("Content-Type", "multipart/form-data");
    }

    request.headers.set("Accept-Language", i18n.language);

    return request;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Redirect on 401 - Unauthorized
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem("accessToken");
      const path = window.location.pathname;
      if (path !== "/" && path !== "/terms") {
        return (window.location.href = "/");
      }
    }
    return Promise.reject(error);
  },
);

export default instance;
